module.exports = __webpack_public_path__ + "static/media/United_transparent_white.18f89b84.png";